import Eventer from 'Lib/Eventer';

const defaultDrawerProperties = {
  isOpen: false,
  title: '',
  content: undefined,
  size: { defaultWidth: 500, minWidth: 400 },
  icon: null,
};

let SiteDrawerData = Eventer.createBus('DRAWER_DATA');

SiteDrawerData.defaultDrawerProperties = defaultDrawerProperties;

let drawerProperties = {
  ...defaultDrawerProperties,
};

SiteDrawerData.isOpen = () => {
  return drawerProperties.isOpen;
};

SiteDrawerData.title = () => {
  return drawerProperties.title;
};

SiteDrawerData.content = () => {
  return drawerProperties.content;
};

SiteDrawerData.size = () => {
  return drawerProperties.size;
};

SiteDrawerData.icon = () => {
  return drawerProperties.icon;
};

SiteDrawerData.open = (newDrawerProperties) => {
  drawerProperties = {
    ...drawerProperties,
    ...newDrawerProperties,
    isOpen: true,
  };

  SiteDrawerData.notifyListeners('DRAWER_OPENED', drawerProperties);
};

SiteDrawerData.close = () => {
  SiteDrawerData.clear();

  SiteDrawerData.notifyListeners('DRAWER_CLOSED', drawerProperties);
};

SiteDrawerData.clear = function () {
  drawerProperties = {
    ...defaultDrawerProperties,
  };

  SiteDrawerData.notifyListeners('DRAWER_CLEARED', drawerProperties);
};

export default SiteDrawerData;
